import { render, staticRenderFns } from "./medicina.vue?vue&type=template&id=c5e583b2"
import script from "./medicina.vue?vue&type=script&lang=js"
export * from "./medicina.vue?vue&type=script&lang=js"
import style0 from "./medicina.vue?vue&type=style&index=0&id=c5e583b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports